export const listCustomer = [
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:true,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:true,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:false,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:true,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:false,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:true,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:true,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:true,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:false,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:true,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:true,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:false,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:true,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:true,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:true,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:false,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:true,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:true,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:true,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:true,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:false,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:true,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:false,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:true,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:false,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:true,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:true,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:false,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:true,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:true,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:true,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:false,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:true,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:true,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:false,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:false,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:true,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:true,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:true,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:true,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:true,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:true,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:true,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:true,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:true,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:true,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:true,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:true,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:true,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:true,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:true,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:true,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:true,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:true,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:true,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:true,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:true,
        fromShop:"Freshbox"
    },
    {
        name: "Eugene Johnson",
        address:"Luck WI, United States",
        email: "tanya.hill@example.com",
        createdAt: "2021/11/02 18:48:47",
        issues:"5",
        status:true,
        fromShop:"Freshbox"
    },

]